import { render, staticRenderFns } from "./CourseSkorochtenieResult.vue?vue&type=template&id=2668df19&scoped=true&"
import script from "./CourseSkorochtenieResult.vue?vue&type=script&lang=js&"
export * from "./CourseSkorochtenieResult.vue?vue&type=script&lang=js&"
import style0 from "./CourseSkorochtenieResult.vue?vue&type=style&index=0&id=2668df19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2668df19",
  null
  
)

export default component.exports